<template>
  <div class="app-wrapper bg-white h-100">
    <div class="app-main">
      <div class="app-content p-0">
        <div class="container d-flex h-100">
          <div class="row justify-content-center align-self-center w-100">
            <div class="col-md-12 text-center"><h3>Logout proccess...</h3></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {},
  mounted() {
    const params = this.$route.params;
    const querys = this.$route.query;
    
    if((params.client == 'bidan' || params.client == 'pharmanet') && querys.token) {
        // if(this.$store.state.BEARER_TOKEN == querys.token) {
            this.$store.commit("SET_BEARER_TOKEN", null);
            this.$store.commit("SET_USER", null);
            this.$store.commit("SET_AUTHERROR", null);
            this.$store.commit("SET_KLINIK_USER", null);
            this.$router.go("/login");
        // }
    }
  }
};
</script>
